import { render, staticRenderFns } from "./ComprobanteFondoRotativoPage.vue?vue&type=template&id=22aa3e06"
import script from "./ComprobanteFondoRotativoPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteFondoRotativoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports